export enum MaintenanceLookupTableNameEnum {
  Star_SpecialEd_Lookup_Duration = 0,
  Star_SpecialEd_Lookup_Frequency = 1,
  Star_SpecialEd_Lookup_IndividualGroup = 2,
  Star_SpecialEd_Lookup_Location = 3,
  Star_SpecialEd_Lookup_Meeting = 4,
  Star_SpecialEd_Lookup_ReferredBy = 5,
  Star_SpecialEd_Lookup_Status = 6
}
